<template lang="pug">
.virtual-slides
  .swiper-container
    .swiper-wrapper
      .swiper-slide.slide-1
      .swiper-slide.slide-2
      .swiper-slide.slide-3
      .swiper-slide.slide-4
      .swiper-slide.slide-5
      .swiper-slide.slide-6
    .swiper-pagination

</template>

<script>
import { Swiper, Pagination, Autoplay } from 'swiper/dist/js/swiper.esm.js'
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'VirtualSlides',
  props:{
    dir: {
      default: 'horizontal',

    },
    initialSlide: {
      default: 0,
    }
  },
  components: {

  },
  data() {
    return {
      swiper: null,
      camera: null,
      x: 0,
      y: 0
    }
  },
  computed: {},
  mounted() {
    Swiper.use([Pagination, Autoplay])
    this.init(this.dir)
    this.camera = document.querySelector('.camera')
  },
  beforeDestroy() {},
  methods: {
    ...mapMutations('app', ['setSceneProgress', 'setCurrSceneIdx']),
    init(dir){
      this.swiper = new Swiper('.swiper-container', {

        direction: dir,
        //direction: 'horizontal',
        initialSlide: this.initialSlide,
        grabCursor: true,
        shortSwipes: true,
        longSwipes: true,
        longSwipesRatio: 0.2,
        centeredSlides: true,
        slidesPerView: 'auto',
        loop: false,

        //touchAngle: 90,
        //virtualTranslate: true,

        // pagination: {
        //   el: '.swiper-pagination',
        //   renderBullet: function (index, className) {
        //     switch (index) {
        //       case 0:
        //         return '<span class="' + className + '">' + '<svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">\n' +
        //           '<use xlink:href="#dot-large"></use>\n' +
        //           '<use xlink:href="#dot-small-1"></use>\n' +
        //           '</svg>' + '</span>'
        //       case 1:
        //         return '<span class="' + className + '">' + '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
        //           '<use xlink:href="#dot-large"></use>\n' +
        //           '<use xlink:href="#dot-small-2"></use>\n' +
        //           '</svg>' + '</span>'
        //       case 2:
        //         return '<span class="' + className + '">' + '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
        //           '<use xlink:href="#dot-large"></use>\n' +
        //           '<use xlink:href="#dot-small-3"></use>\n' +
        //           '</svg>' + '</span>'
        //       case 3:
        //         return '<span class="' + className + '">' + '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
        //           '<use xlink:href="#dot-large"></use>\n' +
        //           '<use xlink:href="#dot-small-4"></use>\n' +
        //           '</svg>' + '</span>'
        //       case 4:
        //         return '<span class="' + className + '">' + '<svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">\n' +
        //           '<use xlink:href="#dot-large"></use>\n' +
        //           '<use xlink:href="#dot-small-1"></use>\n' +
        //           '</svg>' + '</span>'
        //       case 5:
        //         return ''
        //     }
        //
        //   }
        // },
        on: {
          slideChangeTransitionStart: () => {
            this.$emit('slideStart')
          },
          progress: (p) => {
            //console.log(555, p)
            this.setSceneProgress(p)
          },
          slideChange: () => {
            //console.log('change', this.swiper.activeIndex)
            //this.currIdx = this.swiper.activeIndex
            if (this.swiper) {
              this.$emit('sceneChange', this.swiper.activeIndex)
              this.setCurrSceneIdx(this.swiper.activeIndex)
            }

            //console.log(this.currIdx)
          },
          touchStart: (evt) => {

            let ev = evt.touches && evt.touches[0] ? evt.touches[0] : evt
            this.x = ev.pageX / window.innerWidth - 0.5
            this.y = ev.pageY / window.innerHeight - 0.5
          },
          touchMoveOpposite: (evt) => {
            //console.log(evt)
            let ev = evt.touches && evt.touches[0] ? evt.touches[0] : evt
            let x = ev.pageX / window.innerWidth - 0.5
            let y = ev.pageY / window.innerHeight - 0.5
            let diff = {
              x: (x - this.x) * window.innerWidth,
              y: (y - this.y) * window.innerHeight,
            }
            this.x = x
            this.y = y
            //console.log(diff)
            this.camera.components['gyro-position'].touchMove(diff)
          },

        }
      })
    }
  },
  watch: {
    dir(val){
      this.swiper.destroy()
      this.init(val)
    }
  },
}
</script>

<style lang="sass" scoped>
@import "src/styles/common.sass"
@import "src/styles/helpers/swiper.sass"
.virtual-slides
  line-height: 0
  +full()

.swiper-container
  +full()


.swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet
  margin: 0 0.15rem !important
.swiper-container-vertical > .swiper-pagination-bullets .swiper-pagination-bullet
  margin: 0.2rem 0 !important
.swiper-pagination-bullet

  use
    &:first-child
      fill: none
    &:last-child
      fill: #ffffff

.swiper-pagination-bullet-active

  use
    &:first-child
      fill: #fff
    &:last-child
      fill: $cl-lightGold

/* Common Styles */
.swiper-pagination-fraction,
.swiper-pagination-custom,
.swiper-container-horizontal > .swiper-pagination-bullets
  bottom: $ui-margin
  left: 0
  width: 100%

.slide-1
  +full()


</style>
